import { BiChangeSetPreview } from '@euler/model/bi/change-set';
import { createContext, useContext } from 'react';
import { Observable } from 'rxjs';

/** A pending change set drawn as ghosts over the dashboard it changes. */
export interface BiDashboardGhost {
  changeSetId: string;
  /** When it was proposed: of several pending, the newest is drawn. */
  createdAt: string;
  /** The revision it was proposed on; a dashboard that moved drops it. */
  baseRevision: number;
  summary: string;
  preview: BiChangeSetPreview;
}

/**
 * The dashboard a chat is open on, as the cards in that chat see it. Only
 * stable callbacks: the dashboard owns what it draws.
 */
export interface BiDashboardHost {
  dashboardId: string;
  /** The dashboard's revision as drawn: a move may leave a set stale. */
  revision$: Observable<number>;
  /** Draws the ghost until the returned cleanup runs. */
  showGhost: (ghost: BiDashboardGhost) => () => void;
  /**
   * Brings the dashboard into view by closing a full-screen chat; null when
   * the chat sits beside the dashboard.
   */
  reveal: (() => void) | null;
}

export const BiDashboardHostContext = createContext<BiDashboardHost | null>(
  null,
);

export function useBiDashboardHost(): BiDashboardHost | null {
  return useContext(BiDashboardHostContext);
}
